<template>
    <div class="card">
        <div class="card-header">
            个人描述信息
        </div>
        <table class="table table-bordered mb-0">
            <tbody>
            <tr>
                <th class="text-center align-middle" style="width: 15%">个人简介</th>
                <td class="text-left align-middle" style="width: 85%" v-html="personDescriptionInfo.description"></td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 15%">备注信息</th>
                <td class="text-left align-middle" style="width: 85%" v-html="personDescriptionInfo.memo"></td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import userApi from "@/utils/api/user";

export default {
    name: "OrganPersonDescriptionInfoView",
    props: {
        personId: {type: String, required: true},
        personType: {type: Number, required: true},
    },
    data: function () {
        return {
            personDescriptionInfo: {},
        };
    },
    mounted() {
        this.getPersonDescriptionInfo();
    },
    methods: {
        getPersonDescriptionInfo() {
            userApi.person.description.getOrganPersonDescriptionInfo({personId:this.personId, personType: this.personType}).then(res => {
                if (res.data) {
                    let data = res.data;
                    // data.description = data.description.replaceAll("\n","<br/>");
                    // data.memo = data.memo.replaceAll("\n","<br/>");

                    this.personDescriptionInfo = data;
                }
                else {
                    userApi.person.description.updateOrganPersonDescriptionInfo({personId: this.personId, description: '', memo: ''}).then(res2 => {
                        this.personDescriptionInfo = res2.data;
                    })
                }
            })
        },
    }
}
</script>

<style scoped>

</style>